import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { env } from '@/env';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter, Routes } from 'react-router';

import { AuthProvider } from './use-auth';

export const Providers = ({ children }: { children: React.ReactNode }) => {
	const queryClient = new QueryClient();

	return (
		<BrowserRouter>
			<AuthProvider>
				<TooltipProvider>
					<QueryClientProvider client={queryClient}>
						{env.VITE_ENV === 'Dev' ||
							(env.VITE_ENV === 'Test' && (
								<ReactQueryDevtools initialIsOpen={false} />
							))}
						<Routes>{children}</Routes>
						<Toaster />
					</QueryClientProvider>
				</TooltipProvider>
			</AuthProvider>
		</BrowserRouter>
	);
};
